export default function FilePreviewModal({ file, onClose }) {
  if (!file) return null;

  const extension = file.name?.split(".").pop()?.toLowerCase();

  const isImage = ["jpg", "jpeg", "png", "webp"].includes(extension);
  const isPdf = extension === "pdf";

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.78)",
        zIndex: 99999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "95%",
          height: "92vh",
          background: "#fff",
          borderRadius: 20,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 24px 70px rgba(0,0,0,0.4)"
        }}
      >
        <div
          style={{
            padding: "14px 18px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f9fafb",
            gap: 16
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontWeight: 800,
                fontSize: 15,
                color: "#111827",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: 700
              }}
            >
              {file.name}
            </div>

            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
              {file.category || "Genel"} • {extension?.toUpperCase() || "DOSYA"}
            </div>
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <a
              href={file.url}
              target="_blank"
              rel="noreferrer"
              download
              style={{
                padding: "10px 14px",
                borderRadius: 10,
                background: "#fff",
                border: "1px solid #d1d5db",
                textDecoration: "none",
                color: "#111827",
                fontWeight: 700
              }}
            >
              İndir
            </a>

            <button
              onClick={onClose}
              style={{
                padding: "10px 14px",
                borderRadius: 10,
                background: "#ef4444",
                border: "none",
                color: "#fff",
                fontWeight: 700,
                cursor: "pointer"
              }}
            >
              Kapat
            </button>
          </div>
        </div>

        <div
          style={{
            flex: 1,
            background: "#111827",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {isImage && (
            <img
              src={file.url}
              alt={file.name}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain"
              }}
            />
          )}

          {isPdf && (
            <iframe
              src={file.url}
              title={file.name}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                background: "#fff"
              }}
            />
          )}

          {!isImage && !isPdf && (
            <div
              style={{
                background: "#fff",
                padding: 32,
                borderRadius: 18,
                textAlign: "center",
                maxWidth: 460
              }}
            >
              <h2 style={{ marginTop: 0 }}>Önizleme desteklenmiyor</h2>
              <p style={{ color: "#6b7280" }}>
                Bu dosya türü tarayıcı içinde görüntülenemiyor. Dosyayı indirerek açabilirsiniz.
              </p>

              <a
                href={file.url}
                target="_blank"
                rel="noreferrer"
                download
                style={{
                  display: "inline-block",
                  marginTop: 12,
                  padding: "12px 18px",
                  borderRadius: 12,
                  background: "#2563eb",
                  color: "#fff",
                  textDecoration: "none",
                  fontWeight: 800
                }}
              >
                Dosyayı İndir
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}